import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} className="logout-dialog">
      <DialogTitle component="h2">
        {t('logoutConfirmation')}
        <Logout className="logout-icon" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText align="center">
          {t('logoutConfirmationMessage')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={onConfirm} autoFocus>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutModal;
